<template>
  <div class="Users">
    <h3 class="mb-3 text-right">Usuarios registrados</h3>
    <b-card>
      <b-container fluid>
        <!-- User Interface controls -->
        <b-row align-v="center" align-h="between" class="mb-2">
          <b-col sm="4" md="6" cols="6" lg="4" class="my-1">
            <b-button
              pill
              class="btn-card-color text-font-white"
              v-b-modal.modal-register
              >Agregar usuario</b-button
            >
          </b-col>
          <b-col sm="4" md="6" cols="6" lg="4" class="my-1">
            <b-form-group
              label-align-sm="right"
              label-size="sm"
              label-for="filterInput"
              class="mb-0"
            >
              <b-input-group size="md">
                <b-form-input
                  v-model="filter"
                  type="search"
                  id="filterInput"
                  placeholder="Buscar por nombre o correo"
                ></b-form-input>
                <!-- <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''"
                    >X</b-button
                  >
                </b-input-group-append> -->
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col sm="4" md="8" cols="12" lg="4" class="my-1">
            <b-form-group
              label="Por Página"
              label-cols-sm="6"
              label-cols-md="3"
              label-cols-lg="4"
              label-align-sm="right"
              label-size="sm"
              label-for="perPageSelect"
              class="mb-0"
            >
              <b-form-select
                v-model="perPage"
                id="perPageSelect"
                size="md"
                :options="pageOptions"
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- Main table element -->
        <b-table
          show-empty
          small
          stacked="md"
          class="text-left"
          style="font-family: Montserrat; font-weight: lighter; font-size: 14px"
          id="my-table"
          :items="UsersTmp"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          :filterIncludedFields="filterOn"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          @filtered="onFiltered"
          :busy="isBusy"
        >
          <template v-slot:empty>
            <div class="mt-2 text-center">
              <h6>No hay usuarios registrados</h6>
            </div>
          </template>

          <template v-slot:table-busy>
            <div class="text-center text-dark my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong class="ml-2">Cargando...</strong>
            </div>
          </template>

          <template v-slot:emptyfiltered>
            <div class="my-2 text-center">
              <h6>No hay usuarios con esas especificaciones</h6>
            </div>
          </template>

          <template v-slot:cell(active)="row">{{
            row.value == 0 ? "No" : "Si"
          }}</template>

          <template v-slot:cell(actions)="row">
            <b-button
              title="Detalles"
              size="sm"
              variant="white"
              @click="userDetails(row.item)"
            >
              <v-icon name="eye"></v-icon>
            </b-button>

            <b-button
              title="Desactivar usuario"
              @click="changeActive(row.item)"
              v-if="row.item.active == 1"
              size="sm"
              variant="white"
            >
              <v-icon name="user-check" color="green"></v-icon>
            </b-button>
            <b-button
              title="Activar usuario"
              @click="changeActive(row.item)"
              v-if="row.item.active == 0"
              size="sm"
              variant="white"
            >
              <v-icon name="user-times"></v-icon>
            </b-button>

            <b-button
              title="Eliminar"
              size="sm"
              class="mr-1"
              variant="white"
              @click="deleteUser(row.item)"
            >
              <v-icon v-show="!hide" name="trash" color="#CF173C"></v-icon>
              <b-spinner
                v-show="hide"
                small
                variant="danger"
                class="align-middle"
              ></b-spinner>
            </b-button>
          </template>
        </b-table>
        <b-col lg="5" class="mx-auto pt-2">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="fill"
            size="md"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-container>
    </b-card>
    <b-modal
      id="modal-register"
      ref="modal"
      title-class="text-font-black"
      title="Registro de usuario"
      hide-footer
      footer-class="text-font-black"
      @show="resetModal"
      @hidden="resetModal"
    >
      <b-container>
        <form ref="form" @submit.stop.prevent="onSubmitRegister">
          <b-row>
            <b-col lg="6">
              <b-form-group
                label="Nombre"
                label-class="text-light-black"
                label-for="name"
                invalid-feedback="Nombre requerido"
              >
                <b-form-input id="name" v-model="name" required></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group
                label="Apellido"
                label-class="text-light-black"
                label-for="last_name"
                invalid-feedback="Apellido requerido"
              >
                <b-form-input
                  id="last_name"
                  v-model="last_name"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group
                label="Correo Electrónico"
                label-class="text-light-black"
                label-for="Email"
                invalid-feedback="Correo requerido"
              >
                <b-form-input
                  id="email"
                  type="email"
                  v-model="email_register"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group
                label="Teléfono"
                label-class="text-light-black"
                label-for="Phone"
              >
                <b-form-input
                  id="phone"
                  type="number"
                  v-model="phone"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="12">
              <b-form-group
                label="País"
                label-for="country"
                label-class="text-light-black"
                invalid-feedback="País requerido"
              >
                <b-form-select
                  v-model="country"
                  id="country"
                  size="md"
                  :options="countryTmp"
                  required
                ></b-form-select>
              </b-form-group>
              <b-form-group
                label="Estado"
                label-for="state"
                label-class="text-light-black"
                invalid-feedback="Estado requerido"
                v-show="country == 'Venezuela'"
              >
                <b-form-select
                  v-model="state"
                  id="state"
                  size="md"
                  :options="stateTmp"
                  required
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group
                label="Contraseña"
                label-class="text-light-black"
                label-for="state"
                invalid-feedback="Contraseña requerida"
              >
                <b-form-input
                  id="pass"
                  type="password"
                  v-model="password1"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group
                label="Repite la contraseña"
                label-class="text-light-black"
                label-for="state"
                invalid-feedback="Contraseña requerida"
              >
                <b-form-input
                  id="pass1"
                  type="password"
                  v-model="password2"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="6" v-show="!progress1"></b-col>

            <b-col lg="3" v-show="!progress1">
              <b-button
                style="border-radius: 12px; border: none"
                class="p-3"
                size="sm"
                @click="
                  cancel = true;
                  resetModal();
                "
              >
                <span class="text-font-white">Cancelar</span>
              </b-button>
            </b-col>
            <b-col lg="3" v-show="!progress1">
              <b-button
                style="border-radius: 12px; border: none"
                class="btn-card-color p-3"
                size="sm"
                @click="onSubmitRegister()"
              >
                <span class="text-font-white">Agregar</span>
              </b-button>
            </b-col>

            <b-col>
              <div v-show="progress1" class="text-center text-primary mt-3">
                <b-spinner small class="align-middle"></b-spinner>
                <strong class="ml-2">Cargando...</strong>
              </div>
            </b-col>
          </b-row>
        </form>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "Users",
  data() {
    return {
      progress: false,
      progress1: false,
      name: "",
      last_name: "",
      email_register: "",
      country: "",
      state: "",
      phone: "",
      password1: "",
      password2: null,
      hide: false,
      isBusy: false,
      UsersTmp: [],
      Users: [],
      countries: [],
      countryTmp: [],
      states: [],
      stateTmp: [],
      fields: [
        {
          key: "first_name",
          label: "Nombre",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "last_name",
          label: "Apellido",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "email",
          label: "Correo electrónico",
          sortable: true,
        },
        {
          key: "country",
          label: "País",
          sortable: true,
        },
        {
          key: "phone",
          label: "Teléfono",
          sortable: true,
        },
        {
          key: "active",
          label: "Activo",
          sortable: true,
        },
        { key: "actions", label: "Acciones" },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 15, 20],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
    };
  },
  computed: {
    ...mapState({
      me: (state) => state.me,
    }),
  },
  mounted() {
    this.getDataUser();
    this.getCountry();
    this.getState();
  },
  methods: {
    ...mapActions([
      "UserAll",
      "UserUpdate",
      "changeactivateUser",
      "RegisterUserbyAdmin",
      "AllCountry",
      "AllStates",
    ]),
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getDataUser() {
      this.isBusy = true;
      this.UserAll()
        .then((response) => {
          if (response.code == 200) {
            this.UsersTmp = response.data;
            this.totalRows = response.data.length;
            this.isBusy = false;
          }
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            title: "Ha ocurrido un error",
            text: "Intente más tarde",
            icon: "warning",
          });
        });
    },
    UpdateUser() {
      if (
        this.name != null &&
        this.last_name != null &&
        this.country != null &&
        this.phone != null
      ) {
        if (this.country == "Venezuela" && this.city == null) {
          Swal.fire({
            title: "¡Atención!",
            text: "Debe seleccionar un estado",
            icon: "warning",
          });
        } else {
          this.progress = true;
          if (this.country != "Venezuela") {
            this.city = "";
          }
          let form = {
            id: this.id,
            params: {
              first_name: this.name,
              last_name: this.last_name,
              country: this.country,
              email: this.email,
              state: this.city,
              phone: this.phone,
            },
          };
          this.UserUpdate(form).then((response) => {
            if (response.code == 200) {
              Swal.fire({
                title: "Listo",
                text: "Sus datos han sido actualizados",
                icon: "success",
              });
              this.progress = false;
              this.getDataUser();
            } else {
              this.progress = false;

              Swal.fire({
                title: "Error",
                text: "",
                icon: "warning",
              });
            }
          });
        }
      } else {
        Swal.fire({
          title: "¡Atención!",
          text: "No puede dejar campos vacios",
          icon: "warning",
        });
      }
    },
    changeActive(data) {
      let active = data.active === 1 ? 0 : 1;
      let action = data.actions ? false : true;
      let status =
        data.active === 1
          ? "Desactivado correctamente"
          : "Activado correctamente";
      console.log(data);
      let form = {
        user_id: data.id,
        status: data.active === 1 ? "0" : "1",
      };

      Swal.showLoading();
      this.changeactivateUser(form)
        .then((response) => {
          if (response.code === 200) {
            data.active = active;
            data.actions = action;
            Swal.fire({
              title: status,
              icon: "success",
              showConfirmButton: false,
              showLoaderOnConfirm: true,
              timer: 1000,
            });
            this.getDataUser();
          }
        })
        .catch((error) => {
          console.log(error);
          alert("Ocurrió un error, intente más tarde");
          this.getDataUser();
        });
    },
    deleteUser(data) {
      Swal.fire({
        title: "Atención",
        text:
          "¿Está seguro que desea eliminar a " +
          data.first_name +
          " " +
          data.last_name +
          "?",
        icon: "question",
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonColor: "#121419",
        confirmButtonText: "Sí, seguro",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          this.hide = true;
          let form = {
            user_id: data.id,
            status: "2",
          };

          Swal.showLoading();
          this.changeactivateUser(form)
            .then((response) => {
              if (response.code === 200) {
                Swal.fire({
                  title: status,
                  icon: "success",
                  showConfirmButton: false,
                  showLoaderOnConfirm: true,
                  timer: 1000,
                });
                this.hide = false;
                this.getDataUser();
              }
            })
            .catch((error) => {
              console.log(error);
              this.hide = false;

              alert("Ocurrió un error, intente más tarde");
              this.getDataUser();
            });
        }
      });
    },
    userDetails(data) {
      this.$store.commit('CHATROOM', data.room_id)
      this.$router.push("/admin/users/" + data.id);
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.onSubmitRegister();
    },
    resetModal() {
      this.$nextTick(() => {
        this.$bvModal.hide("modal-register");
      });
      this.RecoveryEmail = "";
      this.NameState = null;
      this.name = "";
      this.last_name = "";
      this.email_register = "";
      this.country = "";
      this.state = "";
      this.phone = "";
      this.password1 = "";
      this.password2 = null;
    },
    onSubmitRegister() {
      if (
        this.name == "" ||
        this.last_name == "" ||
        this.country == "" ||
        this.email_register == "" ||
        this.password1 == "" ||
        this.phone == ""
      ) {
        Swal.fire({
          title: "Completa los campos",
          text: "Por favor, completa todos los datos",
          icon: "warning",
        });
      } else {
        if (this.country == "Venezuela" && this.state == "") {
          Swal.fire({
            title: "Completa los campos",
            text: "Por favor, completa todos los datos",
            icon: "warning",
          });
        } else {
          if (this.password1 == this.password2) {
            this.progress1 = true;
            let form = {
              first_name: this.name,
              last_name: this.last_name,
              email: this.email_register,
              country: this.country,
              state: this.state,
              password: this.password1,
              phone: this.phone,
            };
            this.RegisterUserbyAdmin(form)
              .then((response) => {
                console.log(response.data);
                if (response.code == 200) {
                  Swal.fire({
                    title: "Se ha registrado el usuario con éxito",
                    text: "",
                    icon: "success",
                  });
                  this.$nextTick(() => {
                    this.$bvModal.hide("modal-register");
                  });
                  this.progress1 = false;
                } else if (response.code == 409) {
                  Swal.fire({
                    title: "Ya existe un usuario con el email ingresado",
                    text: "Por favor, ingresa un correo valido",
                    icon: "warning",
                  });
                  this.progress1 = false;
                }
              })
              .catch((error) => {
                console.log(error);
                Swal.fire({
                  title: "Correo ingresado no existe",
                  text: "Por favor, ingresa un correo valido",
                  icon: "error",
                });
                this.progress1 = false;
              });
          } else {
            Swal.fire({
              title: "Las contraseñas no coinciden",
              text: "Asegurese de que las contraseñas sean iguales",
              icon: "warning",
            });
          }
        }
      }
    },
    getCountry() {
      this.AllCountry().then((response) => {
        if (response.code == 200) {
          this.countries = response.data;
          this.countries.forEach((element) => {
            this.countryTmp.push({
              value: element.name_en,
              text: element.name_en,
            });
          });
        }
      });
    },
    getState() {
      this.AllStates().then((response) => {
        if (response.code == 200) {
          this.states = response.data;
          this.states.forEach((element) => {
            this.stateTmp.push({
              value: element.state,
              text: element.state,
            });
          });
        }
      });
    },
  },
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&display=swap");
</style>